var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "msg-bell-msg-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: { "padding-top": "10px" }
          },
          [
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TaskName")))]),
                _c("el-input", {
                  staticStyle: { width: "200px", margin: "0 10px" },
                  attrs: {
                    placeholder: _vm.$t("SeaExport.PleaseInputAKeyword")
                  },
                  on: {
                    input: function($event) {
                      return _vm.searchHandle()
                    }
                  },
                  model: {
                    value: _vm.pageInfo.jobNo,
                    callback: function($$v) {
                      _vm.$set(_vm.pageInfo, "jobNo", $$v)
                    },
                    expression: "pageInfo.jobNo"
                  }
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.searchHandle }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.btnAdd } },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.btnCopy } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Copy")))]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.btnEdit } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EditTo")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger" },
                    on: { click: _vm.btnRemoveHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "section grid-wrapper",
            staticStyle: { "flex-grow": "1" }
          },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%" },
              attrs: {
                "config-module": "250821",
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "grid-options": _vm.gridOptions,
                "side-bar": _vm.sideBarDefs
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "250822",
                total: _vm.pageInfo.total,
                page: _vm.pageInfo.pageNum,
                limit: _vm.pageInfo.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.pageInfo, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.pageInfo, "pageSize", $event)
                },
                pagination: _vm.searchHandle
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.addDialog.visible,
            "close-on-click-modal": false,
            title: _vm.addDialog.title,
            width: "450px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.addDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "85px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_TaskName")
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: { no: "taskName" },
                                model: {
                                  value: _vm.addDialog.form.taskName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addDialog.form,
                                      "taskName",
                                      $$v
                                    )
                                  },
                                  expression: "addDialog.form.taskName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_TaskScenario")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  "select-type": _vm.TYPE_NAMES.basic_data_User,
                                  filterable: "",
                                  "default-value":
                                    _vm.addDialog.form.automationConfigUuid ||
                                    "",
                                  "tag-value": "uuid",
                                  "tag-name": "taskName",
                                  "static-options": _vm.automationConfigList,
                                  "filter-tag-names": ["taskName"],
                                  placeholder:
                                    _vm.$t("CargoMsg.Cargo_Select") +
                                    _vm.$t("CargoMsg.Cargo_TaskScenario")
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.addDialog.form.automationConfigUuid =
                                      p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_ExecutionFrequency"
                                )
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.onTypeChanged },
                                  model: {
                                    value: _vm.addDialog.form.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.addDialog.form, "type", $$v)
                                    },
                                    expression: "addDialog.form.type"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: "hour" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_PerHour"))
                                    )
                                  ]),
                                  _c("el-radio", { attrs: { label: "day" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Daily"))
                                    )
                                  ]),
                                  _c("el-radio", { attrs: { label: "week" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Weekly"))
                                    )
                                  ]),
                                  _c("el-radio", { attrs: { label: "mon" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Monthly2"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_StartExecutionTime"
                                )
                              }
                            },
                            [
                              _c("el-time-select", {
                                staticStyle: { width: "145px" },
                                attrs: {
                                  "picker-options": {
                                    start: "00:00",
                                    step: "00:30",
                                    end: "23:30"
                                  },
                                  format: "HH",
                                  placeholder: "请选择小时"
                                },
                                model: {
                                  value: _vm.addDialog.form.startHour,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addDialog.form,
                                      "startHour",
                                      $$v
                                    )
                                  },
                                  expression: "addDialog.form.startHour"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.addDialog.form.type ===
                          _vm.SystemConstants.TIME_TYPE_1.code
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_Every")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "145px" },
                                    attrs: { no: "taskName" },
                                    model: {
                                      value: _vm.addDialog.form.hour,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addDialog.form,
                                          "hour",
                                          $$v
                                        )
                                      },
                                      expression: "addDialog.form.hour"
                                    }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Hour")) +
                                      " "
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.addDialog.form.type === "week"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_SpecifiedWeekday"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      multiple: true,
                                      filterable: "",
                                      "default-multiple-value":
                                        _vm.addDialog.form.weekList || [],
                                      "tag-value": "code",
                                      "tag-name": "chineseName",
                                      "filter-tag-names": ["chineseName"],
                                      cache: false,
                                      "static-options": _vm.weekList,
                                      placeholder: " "
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.addDialog.form.weekList = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.addDialog.form.type === "mon"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_SpecifiedDay")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      multiple: true,
                                      filterable: "",
                                      disabled: _vm.addDialog.form.lastDay,
                                      "default-multiple-value":
                                        _vm.addDialog.form.dayList || [],
                                      "tag-value": "code",
                                      "tag-name": "code",
                                      "filter-tag-names": ["code"],
                                      cache: false,
                                      "static-options": _vm.dayList,
                                      placeholder: " "
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.addDialog.form.dayList = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.addDialog.form.type === "mon"
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { label: "L" },
                                      on: { change: _vm.lastDayHandler },
                                      model: {
                                        value: _vm.addDialog.form.lastDay,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addDialog.form,
                                            "lastDay",
                                            $$v
                                          )
                                        },
                                        expression: "addDialog.form.lastDay"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_LastDayOfMonth"
                                          )
                                        ) + " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_EffectiveTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "145px" },
                                attrs: {
                                  no: "effectiveDateStart",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.addDialog.form.effectiveDateStart,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addDialog.form,
                                      "effectiveDateStart",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "addDialog.form.effectiveDateStart"
                                }
                              }),
                              _vm._v(" - "),
                              _c("el-date-picker", {
                                staticStyle: { width: "145px" },
                                attrs: {
                                  no: "effectiveDateEnd",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.addDialog.form.effectiveDateEnd,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addDialog.form,
                                      "effectiveDateEnd",
                                      $$v
                                    )
                                  },
                                  expression: "addDialog.form.effectiveDateEnd"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_TaskResult")
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "taskResult" },
                                  on: { change: _vm.taskResultHandler },
                                  model: {
                                    value: _vm.addDialog.form.taskResult,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addDialog.form,
                                        "taskResult",
                                        $$v
                                      )
                                    },
                                    expression: "addDialog.form.taskResult"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_TaskResultReminder"
                                      )
                                    ) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  no: "commissionPersonnel",
                                  multiple: true,
                                  filterable: "",
                                  disabled: !_vm.addDialog.form.taskResult,
                                  "default-multiple-value":
                                    _vm.addDialog.form.taskResultUserList || [],
                                  "tag-value": "userId",
                                  "tag-name": "chineseName",
                                  "filter-tag-names": ["chineseName"],
                                  cache: false,
                                  "static-options": _vm.userList,
                                  placeholder: _vm.$t(
                                    "BusinessIntelligence.businessIntelligenceDashboard.selectPersonnel"
                                  )
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.addDialog.form.taskResultUserList =
                                      p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  no: "remarks",
                                  type: "textarea",
                                  rows: 3
                                },
                                model: {
                                  value: _vm.addDialog.form.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.addDialog.form, "remarks", $$v)
                                  },
                                  expression: "addDialog.form.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c("el-button", { on: { click: _vm.onCancel } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ]
      ),
      _vm.logDialog.visible
        ? _c("task-log-dialog", {
            ref: "taskLogDialog",
            attrs: { visible: _vm.logDialog.visible, form: _vm.logDialog.form },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.logDialog, "visible", $event)
              },
              close: function($event) {
                _vm.logDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }